
export * from "./Components/RiderSelection";
export * from "./Components/ProductInfoPortlet";
export * from "./Components/LockerData";
export * from "./Components/PersonDataForm";
export * from "./Components/RentalPropertiesSelection";
export * from "../../../Models/Rental/RiderDetails/ProductAndRiderDetails";

export namespace Components {
    export class RiderDetailsCompBundle {}
}